import { Component } from '@angular/core';
import { CustomModalComponent } from '@components/misc/custom-modal/custom-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { AwButtonComponent } from '@components/misc/aw-button/aw-button.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-new-features-modal',
    imports: [CustomModalComponent, TranslateModule, AwButtonComponent],
    templateUrl: './new-features-modal.component.html',
    styleUrl: './new-features-modal.component.scss'
})
export class NewFeaturesModalComponent {
    constructor(protected modalService: NgbModal) {}
}
